import React, { useState } from "react";
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  Typography,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useLocation, useNavigate } from "react-router-dom";
import { useContext } from "react";
import { QEStrategydataFlowContext } from "../../../main-pages/QEStrategyMainPage";
import { useEffect } from "react";

const pillarsData = [
  {
    label: "Business Capability Mapping",
    value: "Business Capability Mapping",
    percent: "(6.5%)",
  },
  {
    label: "Trust Zone Risk-Based QE",
    value: "Trust Zone Risk-Based QE",
    percent: "(20%)",
  },
  {
    label: "Strategic Outcome Metrics",
    value: "Strategic Outcome Metrics",
    percent: "(18.5%)",
  },
  {
    label: "Shift-Left Testing",
    value: "Shift-Left Testing",
    percent: "(86%)",
  },
  {
    label: "Test Automation and CI/CD",
    value: "Test Automation and CI/CD",
    percent: "(20.5%)",
  },
  {
    label: "Resilience & Scalability Testing",
    value: "Resilience & Scalability Testing",
    percent: "(63%)",
  },
  {
    label: "Security Compliance Validation",
    value: "Security Compliance Validation",
    percent: "(20.5%)",
  },
  {
    label: "Data-Driven Testing",
    value: "Data-Driven Testing",
    percent: "(63%)",
  },
  {
    label: "Observability and Monitoring",
    value: "Observability and Monitoring",
    percent: "(20.5%)",
  },
  {
    label: "Performance & Scalability Testing",
    value: "Performance & Scalability Testing",
    percent: "(63%)",
  },
  {
    label: "Test Environment Testing",
    value: "Test Environment Testing",
    percent: "(20.5%)",
  },
  {
    label: "AI/ML Model Testing",
    value: "AI/ML Model Testing",
    percent: "(63%)",
  },
  {
    label: "CX Usability Testing",
    value: "CX Usability Testing",
    percent: "(20.5%)",
  },
];

const strategyToPillarMap = {
  "Observability Monitoring": "Observability and Monitoring",
  "Shift Left Continuous Testing": "Shift-Left Testing",
  "Performance Engineering": "Performance & Scalability Testing",
  "Security Compliance Validation": "Security Compliance Validation",
  "Trust Zone Risk-Based QE": "Trust Zone Risk-Based QE",
  "Automation All Levels": "Test Automation and CI/CD",
  "Strategic Outcome Metrics": "Strategic Outcome Metrics",
  "Resilience Scalability Testing": "Resilience & Scalability Testing",
  "Test Environment Test Data Management": "Test Environment Testing",
  "CX Usability": "CX Usability Testing",
  "Business Capability Mapping": "Business Capability Mapping",
  "Data Quality Integrity": "Data-Driven Testing",
  "AI ML LLM Governance": "AI/ML Model Testing",
};

export const SuggestedQEPillars = () => {
  const [selected, setSelected] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();

  const {
    topQEpillars,
    finalCSV,
    initialCombinedCSV,
    updatedConfidences,
    backendData,
    topQEpillarsChart,
    pillarsPieChart,
    selectedArchetypes,
  } = location.state || {};

  const handleChange = (value) => {
    setSelected((prev) =>
      prev.includes(value)
        ? prev.filter((item) => item !== value)
        : [...prev, value]
    );
  };

  // Map updatedConfidences probabilities to pillarsData
  const pillarsWithProbabilities = pillarsData.map((pillar) => {
    const matchingConfidence = updatedConfidences?.find(
      (conf) => strategyToPillarMap[conf.strategy] === pillar.value
    );

    return {
      ...pillar,
      percent: matchingConfidence
        ? `${matchingConfidence.probability.toFixed(2)}%`
        : pillar.percent,
    };
  });

  const handleProceed = () => {
    if (selected.length === 0) {
      alert("Please select at least one QE pillar to proceed.");
      return;
    }

    const updatedCSVWithPillars = addSelectedPillarsToCSV(
      initialCombinedCSV,
      selected
    );

    downloadCSV(updatedCSVWithPillars, "qe_strategy_with_selected_pillars.csv");

    navigate("/dashboard/qe-strategy/advisory-layer/selected-pillars", {
      state: {
        selected: selected,
        updatedCSV: updatedCSVWithPillars,
        topQEpillars: topQEpillars,
        finalCSV: finalCSV,
        initialCombinedCSV: initialCombinedCSV,
        updatedConfidences: updatedConfidences,
      },
    });
  };

  const addSelectedPillarsToCSV = (csvData, selectedPillars) => {
    if (!csvData || selectedPillars.length === 0) return csvData;

    const lines = csvData.trim().split("\n");
    if (lines.length < 2) return csvData;

    const headerLine = lines[0];
    const dataLine = lines[1];

    const pillarHeaders = selectedPillars.join(",");
    const pillarValues = "";

    const updatedHeader = headerLine + "," + pillarHeaders;
    const updatedDataRow = dataLine + "," + pillarValues;

    const updatedCSV = updatedHeader + "\n" + updatedDataRow;

    return updatedCSV;
  };

  const downloadCSV = (csvContent, filename) => {
    try {
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const downloadLink = document.createElement("a");
      downloadLink.href = URL.createObjectURL(blob);
      downloadLink.download = filename;
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
      URL.revokeObjectURL(downloadLink.href);
    } catch (error) {
      console.error("Error downloading CSV:", error);
    }
  };

  const handleBack = () => {
    // navigate("/dashboard/qe-strategy/advisory-layer", {
    //   state: {
    //     topQEpillars: location.state?.topQEpillars || topQEpillars,
    //     backendData: location.state?.backendData || backendData,
    //     topQEpillarsChart: location.state?.topQEpillarsChart,
    //     pillarsPieChart: location.state?.pillarsPieChart,
    //     selectedArchetypes: location.state?.selectedArchetypes,
    //     finalCSV: location.state?.finalCSV || finalCSV,
    //     initialCombinedCSV: location.state?.initialCombinedCSV || initialCombinedCSV,
    //     updatedConfidences: location.state?.updatedConfidences || updatedConfidences,
    //     uploadedCSV: location.state?.finalCSV || location.state?.uploadedCSV || "",
    //   },
    // });
    navigate(-1);
  };

  return (
    <Box>
      <Box p={3} maxWidth="100%" mx="auto">
        <Typography variant="h6" mb={2} sx={{ fontWeight: 600, fontSize: "20px", fontStyle: "SemiBold" }}>
          Human in the loop Suggested QE Pillars
        </Typography>

        <Grid container spacing={2}>
          {pillarsWithProbabilities.map((pillar, index) => (
            <Grid item xs={12} sm={6} key={index}>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                border="1px solid #eee"
                borderRadius={2}
                px={2}
                py={1.5}
                bgcolor={selected.includes(pillar.value) ? "#e3f2fd" : "#fff"}
                sx={{
                  cursor: "pointer",
                  transition: "0.2s",
                  "&:hover": { boxShadow: 2, bgcolor: "#f5f8fa" },
                }}
                onClick={() => handleChange(pillar.value)}
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={selected.includes(pillar.value)}
                      onChange={() => handleChange(pillar.value)}
                    />
                  }
                  label={
                    <Typography
                      variant="body1"
                      sx={{ fontSize: "16px", fontStyle: "Medium", fontWeight: 500 }}
                    >
                      {pillar.label}
                    </Typography>
                  }
                  sx={{ marginRight: 0, flex: 1, cursor: "pointer", pointerEvents: "none" }}
                />
                <Typography
                  variant="body2"
                  sx={{
                    color: "#0094FB",
                    fontWeight: 500,
                    fontSize: "16px",
                    fontStyle: "SemiBold",
                  }}
                >
                  ({pillar.percent})
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>

      <Box
        mt={4}
        display="flex"
        justifyContent="space-between"
        sx={{
          position: "sticky",
          bottom: 0,
          backgroundColor: "#f6f3f2",
          padding: 1.2,
          paddingLeft: 3,
          paddingRight: 3,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
          boxSizing: "border-box",
        }}
      >
        <Button
          variant="outlined"
          sx={{ minWidth: 110, textTransform: 'none', fontSize: "16px", border: '2px solid #0094FB', borderRadius: '8px', gap: '8px' }}
          startIcon={<ArrowBackIcon />}
          onClick={handleBack}
        >
          Back
        </Button>
        <Button
          variant="contained"
          sx={{
            minWidth: 110,
            textTransform: "none",
            backgroundColor: selected.length > 0 ? "#0094FB" : undefined,
            fontSize: "16px",
            border: selected.length > 0 ? '2px solid #0094FB' : 'none',
            borderRadius: '8px',
            gap: '8px'
          }}
          endIcon={<ArrowForwardIcon />}
          onClick={handleProceed}
          disabled={selected.length === 0}
        >
          Proceed
        </Button>
      </Box>
    </Box>
  );
};